<div class="language-selector">
  <label for="language-select">{{ 'LANGUAGE' | translate }}:</label>
  <select
    id="language-select"
    [(ngModel)]="currentLanguage"
    (change)="changeLanguage(currentLanguage)"
    class="form-select"
    >
    @for (lang of supportedLanguages; track lang) {
      <option [value]="lang">
        {{ getLanguageName(lang) }}
      </option>
    }
  </select>
</div>
